import { Lock } from "lucide-react";

// Subtle sitewide ribbon signalling the private-beta stage.
export function BetaBanner() {
  return (
    <div className="w-full bg-[#0B1F2E] text-emerald-50 text-center text-xs py-1.5 px-4 flex items-center justify-center gap-2 border-b border-emerald-500/20" data-testid="beta-banner">
      <Lock className="h-3 w-3 text-emerald-400" />
      <span className="tracking-wide">
        <span className="font-bold">Private Beta</span> — Learn Me is invite-only while we finish polishing the Dojo.
      </span>
    </div>
  );
}
